import { useId, useState, useEffect } from "react";
import classNames from "classnames";
import InputMask from "@mona-health/react-input-mask";

export default function PasswordField({
  label,
  value,
  onChange,
  id,
  className,
  errors = [],
  placeholder,
  disabled = false,
}) {
  const inputId = id || useId();

  if (typeof onChange !== "function")
    console.debug("A text field doesn't have an onChange callback");

  const [isValid, setIsValid] = useState(errors.length == 0);

  useEffect(() => {
    setIsValid(errors.length == 0);
  }, [errors]);

  const handleChange = (event) => {
    if (typeof onChange === "function")
      onChange(event.target.value);

    setIsValid(true);
  };

  return (
    <div className="inpt-grp">
      {label && (
        <label htmlFor={inputId} className="lbl">{label}</label>
      )}

      <input
        type="password"
        id={inputId}
        placeholder={placeholder}
        className={className || classNames("inpt-text", { "inpt--error": !isValid })}
        onChange={handleChange}
        value={value}
        disabled={disabled}
      />

      {!isValid && errors.map((error, index) => (
        <label key={index} className="lbl lbl--error">{error}</label>
      ))}
    </div>
  );
}
